<template>
  <b-container fluid class="pb-5">
    <AdminTabs isCard>
      <AdminTab name="Matured" :selected="true">
        <AdminCard :customStyle="customStyle">
          <template v-slot:header>
            <div class="vault-header">
              <div class="vault-title">MATURED VAULTS</div>
              <div style="display: flex">
                <AdminTextField
                  prependIcon="/images/icons/search.svg"
                  :customStyle="{ padding: '0 20px' }"
                  v-model="filter_mature.search"
                  :debounce="600"
                />

                <div class="vault-filter">
                  <AdminVaultFilter v-model="filter_mature" />

                  <AdminButton
                    color="green"
                    @click="$router.push('/admin/vault/create')"
                  >
                    create
                  </AdminButton>
                </div>
              </div>
            </div>
          </template>
          <AdminDatatable
            url="/api/admin/vault?type=matured"
            :headers="headers"
            :filter="filter_mature"
            @detail="detail($event)"
          >
            <template v-slot:network="{ item }">
              {{ item.network.toUpperCase() }}
            </template>
            <template v-slot:token="{ item }">
              {{ item.token.toUpperCase() }}
            </template>
            <template v-slot:type="{ item }">
              {{ formattingType(item.type) }}
            </template>
            <template v-slot:nut="{ item }">
              {{ capitalizeFirstLetter(item.nut) }}
            </template>
            <template v-slot:time_period="{ item }">
              {{ capitalizeFirstLetter(item.time_period) }}
            </template>
            <template v-slot:apy="{ item }">
              {{ `+${item.apy}` }}
            </template>
            <template v-slot:max_deposit="{ item }">
              {{ calculateDeposit(item) }}
            </template>
            <template v-slot:state="{ item }">
              {{ capitalizeFirstLetter(item.state) }}
              <!-- <AdminVaultStateDropdown :text="item.state" /> -->
            </template>
            <template v-slot:action="{ item }">
              <AdminCopyDropdown :state="item.state" />
            </template>
          </AdminDatatable>
        </AdminCard>
      </AdminTab>

      <AdminTab name="All">
        <AdminCard :customStyle="customStyle">
          <template v-slot:header>
            <div class="vault-header">
              <div class="vault-title">ALL VAULTS</div>
              <div style="display: flex">
                <AdminTextField
                  prependIcon="/images/icons/search.svg"
                  :customStyle="{ padding: '0 20px' }"
                  v-model="filter_all.search"
                  :debounce="600"
                />

                <div class="vault-filter">
                  <AdminVaultFilter v-model="filter_all" all />

                  <AdminButton
                    color="green"
                    @click="$router.push('/admin/vault/create')"
                    >create</AdminButton
                  >
                </div>
              </div>
            </div>
          </template>
          <AdminDatatable
            url="/api/admin/vault?type=all"
            :headers="headers"
            :filter="filter_all"
            @detail="detail($event)"
          >
            <template v-slot:network="{ item }">
              {{ item.network.toUpperCase() }}
            </template>
            <template v-slot:token="{ item }">
              {{ item.token.toUpperCase() }}
            </template>
            <template v-slot:type="{ item }">
              {{ formattingType(item.type) }}
            </template>
            <template v-slot:nut="{ item }">
              {{ capitalizeFirstLetter(item.nut) }}
            </template>
            <template v-slot:time_period="{ item }">
              {{ capitalizeFirstLetter(item.time_period) }}
            </template>
            <template v-slot:apy="{ item }">
              {{ `+${item.apy}` }}
            </template>
            <template v-slot:max_deposit="{ item }">
              {{ calculateDeposit(item) }}

              <!-- {{ moneyFormat(item.max_deposit) }} -->
            </template>
            <template v-slot:state="{ item }">
              {{ capitalizeFirstLetter(item.state) }}
              <!-- <AdminVaultStateDropdown :text="item.state" /> -->
            </template>
            <template v-slot:action="{ item }">
              <AdminCopyDropdown :state="item.state" />
            </template>
          </AdminDatatable>
        </AdminCard>
      </AdminTab>
    </AdminTabs>
  </b-container>
</template>

<script>
import AdminCard from "../../../components/Admin/UI/AdminCard.vue";
import AdminDatatable from "../../../components/Admin/UI/Table/AdminDatatable.vue";
import AdminCopyDropdown from "../../../components/Admin/UI/Table/AdminCopyDropdown.vue";
import AdminButton from "../../../components/Admin/UI/Button/AdminButton.vue";
import AdminTabs from "../../../components/Admin/UI/AdminTabs.vue";
import AdminTab from "../../../components/Admin/UI/AdminTab.vue";
import AdminVaultStateDropdown from "../../../components/Admin/UI/Table/AdminVaultStateDropdown.vue";
import AdminTextField from "../../../components/Admin/UI/Input/AdminTextField.vue";
import AdminVaultFilter from "../../../components/Admin/UI/Table/AdminVaultFilter.vue";

export default {
  components: {
    AdminCard,
    AdminDatatable,
    AdminButton,
    AdminTabs,
    AdminTab,
    AdminVaultStateDropdown,
    AdminCopyDropdown,
    AdminTextField,
    AdminVaultFilter,
  },
  data() {
    return {
      customStyle: {
        padding: "10px 20px",
        borderRadius: "4px",
      },
      headers: [
        {
          text: "Network",
          value: "network",
          orderable: true,
          clicked: true,
          sloted: true,
        },
        {
          text: "Token",
          value: "token",
          orderable: true,
          clicked: true,
          sloted: true,
        },
        { text: "Type", value: "type", orderable: true, sloted: true },
        {
          text: "Time Period",
          value: "time_period",
          orderable: true,
          sloted: true,
        },
        { text: "APY", value: "apy", orderable: true, sloted: true },
        {
          text: "Vault Deposits (USD)",
          value: "max_deposit",
          //   orderable: true,
          sloted: true,
        },
        { text: "State", value: "state", orderable: true, sloted: true },
        // { text: "Action", value: "action", sloted: true },
      ],
      filter_mature: {
        search: null,
        chain: [],
        token: [],
        type: [],
        period: [],
        state: [],
      },
      filter_all: {
        search: null,
        chain: [],
        token: [],
        type: [],
        period: [],
        state: [],
      },
    };
  },
  methods: {
    detail(value) {
      this.$router.push(`/admin/vaultdetail/${value.id}`);
    },
    calculateDeposit(item) {
      if (item.vault_detail) {
        return this.moneyFormat(item.usd_price * item.total_deposit);
      } else {
        return 0;
      }
    },
  },
  watch: {
    filter: {
      deep: true,
      handler(v) {
        //
      },
    },
  },
};
</script>


<style scoped>
.vault-header {
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
  padding: 10px 0;
  border-bottom: 1px solid rgba(234, 237, 240, 1);
}

.vault-title {
  font-size: 20px;
  font-weight: bold;
}

.vault-filter {
  padding-left: 20px;
  border-left: 1px solid rgba(234, 237, 240, 1);
  display: flex;
  gap: 10px;
}
</style>
